import {
    Injectable, inject
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";

import { ImageCropperDialogComponent } from "../../dialogs/image-cropper/image-cropper-dialog.component";
import { IImageCropperDialogData } from "../../dialogs/image-cropper/interface/image-cropper-dialog-data";
import { IImageCropperDialogResult } from "../../dialogs/image-cropper/interface/image-cropper-dialog-result";

/**
 * Opens the shared {@link ImageCropperDialogComponent}.
 *
 * The cropper is never embedded in a form — every consumer opens it here.
 *
 * @example
 * ```typescript
 * this._cropperDialogService.openImageCropper$({ imageSource: url, width: 500, height: 500 })
 *     .subscribe((result) => { ... });
 * ```
 */
@Injectable({
    providedIn: "root"
})
export class ImageCropperDialogService {

    private readonly _dialog = inject(MatDialog);

    /**
     * Opens the cropper dialog.
     *
     * @param data - The image to crop and any required output size
     * @returns An observable that emits the result when the dialog closes, or `undefined` on cancel
     */
    openImageCropper$(data: IImageCropperDialogData): Observable<IImageCropperDialogResult | undefined> {

        const dialogRef = this._dialog.open<ImageCropperDialogComponent, IImageCropperDialogData, IImageCropperDialogResult>(
            ImageCropperDialogComponent,
            {
                width: "720px",
                data: data
            }
        );

        return dialogRef.afterClosed();
    }
}
